export default __webpack_public_path__ + "static/media/bjTLnds.f8678cc8.webp";